/* import __COLOCATED_TEMPLATE__ from './sh-check.hbs'; */
import { or } from '@ember/object/computed';
import Component from '@ember/component';
import { computed } from '@ember/object';

export default Component.extend({
  tagName: 'span',
  classNameBindings: ['readonly:readonly'],
  isDisabled: or('disabled', 'readonly'),
  inputClasses: computed('invalid', 'readonly', function () {
    let classes = ['filled-in'];
    let checkClasses = ['invalid', 'readonly'];
    let self = this;
    checkClasses.forEach(function (cssClass) {
      if (self.get(cssClass)) {
        classes.push(cssClass);
      }
    });
    return classes.join(' ');
  }),
});
